<script lang="ts">
	import type { BlogPageMetadata } from '$lib/types/BlogPageMetadata';

	import { BLOG_PAGES_DIRECTORY } from '$routes/(non-app)/blog/BLOG_PAGES_DIRECTORY';
	import { tocCrawler } from '@skeletonlabs/skeleton';
	import CTASubscribePage from '@tickrr/ui/components/v2/modules/marketing/CTASubscribePage.svelte';
	import _ from 'lodash';

	import BlogCtaCard from './BlogCTACard.svelte';
	import BlogPageCard from './BlogPageCard.svelte';
	import BlogTOC from './BlogTOC.svelte';

	export let blogMetadata: BlogPageMetadata;

	let el: HTMLElement;
</script>

<div id="blog-page" data-testid="blog-page">
	<div class="blog-page-header">
		<h1 class="blog-title">{blogMetadata.title}</h1>
		<span class="date-published">{blogMetadata.datePublished}</span>
	</div>

	<div id="blog-main" data-testid="blog-main">
		<div id="blog-content-col" data-testid="blog-content-col">
			<article
				bind:this={el}
				id="blog-content"
				use:tocCrawler={{ mode: 'generate', scrollTarget: '#page' }}
			>
				<img
					alt={blogMetadata.title}
					loading="eager"
					src={blogMetadata.headerImage}
					class="header-image"
				/>
				<slot />
			</article>
		</div>

		<div id="blog-side-panel-col" data-testid="blog-side-panel-col">
			<div class="sticky-container">
				<BlogTOC />
				<BlogCtaCard />
			</div>
		</div>
	</div>

	<p class="blog-title my-4 px-4 max-tablet:text-center">More from the Tickrr Blog</p>
	<div class="flex gap-x-4 overflow-auto p-4">
		{#each _.shuffle(Object.entries(BLOG_PAGES_DIRECTORY)) as [slug, post] (slug)}
			<BlogPageCard metadata={post} {slug} />
		{/each}
	</div>

	<CTASubscribePage imgClasses="!max-h-[480px]" isTransitionEnabled={false} />
</div>
